module.exports = __webpack_public_path__ + "static/img/Mww128.343a793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mww128.png
// module id = 120
// module chunks = 1